export default __webpack_public_path__ + "static/media/640_business01-es-web.0ff64d3f.png";